export default __webpack_public_path__ + "static/media/flag-galapagos-islands.e119638b.svg";